import React from "react"

import BackgroundImage from "../../../../common/BackgroundImage"
import SideRemoveButton from "../../../../common/SideRemoveButton"
import Tags from "../../../../common/tags/Tags"
import TagItem from "../../../../common/tags/TagItem"

const CommunityEditParticipantListItem = props => (
    <div className="list-group-item">
        <BackgroundImage
            classList={["list-group-item-thumb", "people-circle"]}
            imageUrl={props.photo_url}
        />
        <div className="list-group-item-content">
            <h4 className="text-shorten-single-line">
                {props.full_name}&nbsp;
                <span className="small">{props.primary_position}</span>
            </h4>
            <p className="primary-organisation">{props.primary_organisation}</p>
            {props.canBePromoted && (
                <button
                    className="btn btn-primary promote-button"
                    onClick={props.promoteMember(props)}
                >
                    Promote
                </button>
            )}
            {(props.type === "managers" || props.canBePromoted) && (
                <SideRemoveButton
                    onClick={props.removeParticipant(props, props.type)}
                />
            )}
            {props.is_manager && (
                <Tags>
                    <TagItem isGrey={true}>Manager</TagItem>
                </Tags>
            )}
        </div>
    </div>
)

export default CommunityEditParticipantListItem
